const WORDS = [
  "Peinture intérieure", "Ravalement de façade", "Peintures Écolabel", "Garantie décennale",
  "Toile de verre", "Parquet & lino", "Artisan angevin", "Devis gratuit sous 48h",
];

export const Marquee = () => {
  const row = (k) => (
    <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
      {WORDS.map((w, i) => (
        <span key={i} className="flex items-center">
          <span className={`px-8 font-display text-4xl sm:text-6xl ${i % 2 ? "italic text-paper/55" : "text-paper"}`}>{w}</span>
          <svg viewBox="0 0 20 20" className="h-4 w-4 sm:h-5 sm:w-5 fill-gold"><path d="M10 0l2.4 7.6L20 10l-7.6 2.4L10 20l-2.4-7.6L0 10l7.6-2.4z" /></svg>
        </span>
      ))}
    </div>
  );
  return (
    <section data-testid="editorial-marquee" className="overflow-hidden border-y border-ink-line bg-ink py-8 sm:py-10">
      <div className="marquee-track">{[0, 1].map(row)}</div>
    </section>
  );
};
